































































































































































import { Component, Vue, Emit } from "vue-property-decorator";
import { User } from "@/interfaces/user";
import { StudioState } from "@/interfaces/studioState";
import EventDescriptionEditor from "@/components/EventDescriptionEditor.vue";
import { EventService } from "@/services/eventService";
import { VibrixEvent, VibrixEventMailTemplate } from "@/interfaces/vibrixEvent";
import { DateService } from "@/services/dateService";
import EventMailTemplatesEditor from "@/components/EventMailTemplatesEditor.vue";

@Component({ components: { EventDescriptionEditor, EventMailTemplatesEditor } })
export default class EventCreationForm extends Vue {
    public showPicker = false;
    public formValid: boolean = false;

    public eventTitle: string = "";
    public eventStartDate: string = new Date().toISOString().substr(0, 10);
    public eventStartTime: string = new Date()
        .toLocaleTimeString()
        .substr(0, 5);
    public eventDuration: number = 30;
    public selectedStudio: string | null = null;
    public isPrivate: boolean = false;

    public eventDescription: string = "";
    public eventDescriptionDialog: boolean = false;

    public eventJoinDescription: string = "";
    public eventJoinDescriptionDialog: boolean = false;

    public eventEmailDialog: boolean = false;

    public eventMails: VibrixEventMailTemplate = {
        reminderEmail: "",
        registerEmail: "",
        cancelEmail: "",
        followupEmailJoined: "",
        followupEmailNoShow: "",
    };
    public loading: boolean = false;

    public token: string = "";

    public navigator = navigator;

    @Emit() public eventCreated(event: VibrixEvent): VibrixEvent {
        return event;
    }

    @Emit() public cancel() {
        return;
    }

    public get startDateTime(): string {
        return new Date(
            `${this.eventStartDate}T${this.eventStartTime}`
        ).toISOString();
    }

    public get endDateTime(): string {
        const startDateTime = new Date(this.startDateTime);
        return new Date(
            startDateTime.getTime() + this.eventDuration * 1000 * 60
        ).toISOString();
    }

    public formatDateTime(date: string) {
        return DateService.formatDateTime(date, this.$i18n.locale);
    }

    public get user(): User | null {
        return this.$store.state.user;
    }

    public get studios(): StudioState[] {
        return this.user?.own_studios.map(s => s.studio) ?? [];
    }

    public get datePickerOptions() {
        return {
            min: new Date().toISOString().substr(0, 10),
        };
    }

    public dateParse(date: string) {
        const [year, month, day] = date.split("-");
        return `${year}-${month}-${day.substr(0, 2)}`;
    }

    public get rules(): { [key: string]: (v: string) => boolean | string } {
        return {
            required: v => !!v || (this.$t("studio.required") as string),
            length: v =>
                v.length < 255 || (this.$t("guest.username.invalid") as string),
            maxDuration: v =>
                (parseInt(v) > 0 && parseInt(v) <= 180) ||
                (this.$t("event.form.duration") as string),
        };
    }
    public async mounted() {
        if (this.$auth.isAuthenticated) {
            this.token = await this.$auth.getTokenSilently();
        }
        this.eventMails.followupEmailNoShow = this.$t(
            "event.mailTemplateTexts.followupEmailNoShowTemplate"
        ).toString();
        this.eventMails.followupEmailJoined = this.$t(
            "event.mailTemplateTexts.followupEmailJoinedTemplate"
        ).toString();
        this.eventMails.registerEmail = this.$t(
            "event.mailTemplateTexts.registerEmailTemplate"
        ).toString();
        this.eventMails.reminderEmail = this.$t(
            "event.mailTemplateTexts.reminderEmailTemplate"
        ).toString();
        this.eventMails.cancelEmail = this.$t(
            "event.mailTemplateTexts.cancelEmailTemplate"
        ).toString();
    }
    public async submit() {
        this.loading = true;
        try {
            if (!this.selectedStudio) {
                return;
            }
            const event = await EventService.createEvent(
                {
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    studio_id: this.selectedStudio,
                    title: this.eventTitle,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    start_time: this.startDateTime,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    end_time: this.endDateTime,
                    description: this.eventDescription,
                    join_description: this.eventJoinDescription,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    is_private: this.isPrivate,
                    invitationList: [],
                    blockList: [],
                    mailTemplates: this.eventMails,
                },
                this.token
            );
            this.eventCreated(event);
        } finally {
            this.loading = false;
        }
    }
}
